export const ReferrerActionTypes = {
  REQUEST_EXTOLE_JWT: 'REQUEST_EXTOLE_JWT',
  GET_EXTOLE_JWT_SUCCESS: 'GET_EXTOLE_JWT_SUCCESS',
  GET_EXTOLE_JWT_FAILURE: 'GET_EXTOLE_JWT_FAILURE',
  SET_EXTOLE_JWT_LOADING: 'SET_EXTOLE_JWT_LOADING',
};
